import CustomCard from '../../../src/components/card/CustomCard'
import CardBody from '../../../src/components/card/CardBody'
import CardFooter from '../../../src/components/card/CardFooter'
import useInput, { useInputWithMaxLength } from '../../hooks/useInput'
import { useDispatch, useSelector } from 'react-redux'
import { loginUser, resetLoginSlice } from '../../redux/slices/loginSlice'
import CustomButton from '../../components/CustomButton'
import React, { useEffect, useState } from 'react'
import { setAuthToken } from '../../redux/slices/authTokenSlice'
import Input, { InputIcon } from '../../components/form/Input'
import { CustomSpinner } from '../../components/CustomSpinner'
import CustomMessage from '../../components/CustomMessage'
import { ReactComponent as LogoWhiteSvg } from '../../assets/img/svgs/logo_white.svg'
import {isValidEmail} from "../../helpers/validationHelper";

export default function LoginForm() {
  const phone = useInputWithMaxLength('', 10)
  const password = useInput('')
  const dispatch = useDispatch()
  const isFormFilled = () =>
    password.value.trim() && isValidEmail(phone.value.trim())

  const { success, loading, error } = useSelector((state) => state.login)

  const [passwordVisible, setPasswordVisible] = useState(false)

  useEffect(() => {
    dispatch(setAuthToken())
  }, [success, dispatch])

  useEffect(() => {
    return () => {
      dispatch(resetLoginSlice())
    }
  }, [dispatch])

  return (
    <>
      <div className="flex justify-center mb-6">
        <LogoWhiteSvg width={120} />
      </div>
      <CustomCard className="relative shadow-xl shadow-slate-800">
        <div className="text-center justify-center pt-6 mb-1">
          <div className="text-2xl font-bold">
            Admin Login
          </div>
          {loading && (
            <CustomSpinner className="text-secondary-500 absolute right-4 top-3" />
          )}
        </div>
        <CardBody className="py-0">
          <div className="h-12 mb-2">
            {error && <CustomMessage message={error} messageType="error" />}
          </div>
          <Input
            value={phone.value}
            name="phone"
            type="text"
            onChange={phone.onChange}
            disabled={loading}
            label="Email"
          />
          <Input
            value={password.value}
            name="password"
            type={passwordVisible ? 'text' : 'password'}
            onChange={password.onChange}
            disabled={loading}
            postIcon={
              <InputIcon
                icon={passwordVisible ? 'visibility' : 'visibility_off'}
                onClick={() => setPasswordVisible(!passwordVisible)}
              />
            }
            label="Password"
          />
        </CardBody>
        <CardFooter className="pt-1">
          <CustomButton
            className="w-full justify-center"
            disabled={!isFormFilled() || loading}
            onClick={login}
          >
            Login
          </CustomButton>
        </CardFooter>
      </CustomCard>
    </>
  )

  function login() {
    dispatch(
      loginUser({
        email: phone.value.trim(),
        password: password.value.trim(),
      }),
    )
  }
}
